import { render } from "./hz-dialog.vue?vue&type=template&id=0e24c103"
import script from "./hz-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./hz-dialog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hz-dialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e24c103"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e24c103', __exports__)) {
    api.reload('0e24c103', __exports__)
  }
  
  module.hot.accept("./hz-dialog.vue?vue&type=template&id=0e24c103", () => {
    api.rerender('0e24c103', render)
  })

}


export default __exports__